import React from 'react';
import styled from 'styled-components';

import { ConsumerOrder } from 'src/components/embedded-account/account.types';
import { CarouselV2 } from 'src/components/carousel-v2/carousel-v2';

import { OrderCard } from './order-card';

type OrdersTabProps = {
  orders: ConsumerOrder[];
  reorder: (order: ConsumerOrder) => Promise<void>;
  loadingOrderId: string | null;
  handleViewOrder: (order: ConsumerOrder) => void;
};

export function MobileOrdersTab({ orders, reorder, loadingOrderId, handleViewOrder }: OrdersTabProps): JSX.Element {
  return (
    <CarouselV2 hideTitle hideLink mt='0'>
      {orders.map((order) => (
        <CardWrapper key={order.orderId}>
          <OrderCard
            order={order}
            onReorder={() => void reorder(order)}
            reorderLoading={loadingOrderId === order.orderId}
            onViewOrder={() => handleViewOrder(order)}
          />
        </CardWrapper>
      ))}
    </CarouselV2>
  );
}

const CardWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
`;
